import css from 'styled-jsx/css';

export default css.global`


.nav__header {
  background: transparent;
  padding: 2rem 0;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 1006;
  transition: all 200ms ease-in-out;
  font-size: 14px;
}

.ml-auto {
  margin-left: auto !important;
}

.nav__header.shrink {
  padding: 12px 0;
  background: #fff;
  box-shadow: 0px 0px 5px #c6c6c6;
}

.nav__bar {
  display: flex;
  align-items: center;
}

.nav__bar-logo {
  align-items: center;
}

.nav__bar-logo img {
  width: 260px;
}

.nav__toggler {
  margin-left: auto;
  background: transparent;
  border: none;
  border-radius: 25px;
  padding: 3px 10px;
  color: #b1272c;
  font-size: 24px;
}

.nav__mobile {
  position: fixed;
  height: 100vh;
  background: rgb(255, 255, 255);
  width: 100%;
  top: 0;
  left: -100%;
  transition: left 300ms ease-in;
  overflow-y: auto;
  z-index: 2000;
}

.nav__mobile.open {
  left: 0;
}

.nav__mobile-title {
  display: flex;
  align-items: center;
  padding: 1rem;
  background: #fff;
}

.nav__mobile-title .back {
  border: none;
  background: transparent;
  font-size: 16px;
  padding: 5px 10px;
  color: rgb(56, 56, 56);
}

.nav__mobile-title .logo {
  width: 100px;
  margin-left: 1rem;
}

.nav__mobile-title .close {
  color: #b1272c !important;
  margin-left: auto;
  font-size: 24px;
  padding: 5px 10px;
  opacity: 1;
}

.nav__bar-menu {
  padding-left: 2rem;
  padding-top: 2rem;
  list-style: none;
  text-align: center;
  padding-inline-start: 0;
}

.nav__mobile .nav__bar-menu-item {
  margin-bottom: 26px;
}

.nav__bar-menu-link {
  color: #495057;
  font-size: 18px;
  text-decoration: none;
  cursor: pointer;
}

.nav__bar-menu-link:hover,
.nav__bar-menu-link:focus,
.nav__bar-menu-link:active {
  color: #b1272c;
  text-decoration: none;
}

.nav__mobile-menu-wrapper {
  position: relative;
}

.sub-menu {
  position: fixed;
  height: 100vh;
  background: rgb(255, 255, 255);
  width: 100%;
  top: 50px;
  left: -100%;
  transition: left 300ms ease-in;
  overflow-y: auto;
}

.sub-menu.open {
  left: 0;
}

.web__nav-wrapper {
  position: relative;
  display: none;
  flex: 1;
}

.web-submenu {
  position: absolute;
  left: -100px;
  box-shadow: 0px 0px 5px #ebebeb;
  border-radius: 10px;
  overflow: hidden;
}

@media (min-width: 1023px) {
  .nav__toggler {
    display: none;
  }

  .nav__bar-menu {
    flex-direction: row;
    align-items: center;
    padding: 0;
    margin: 0;
    gap: 26px;
    display: flex;
  }

  .nav__bar-menu.cta-links {
    gap: 16px;
  }

  .nav__bar-menu-link {
    font-size: 14px;
  }

  .nav__bar-logo {
    margin-right: 3rem;
  }

  .web__nav-wrapper {
    display: block;
  }

  .web-submenu {
    left: -150px;
    width: 970px;
  }
}
@media (min-width: 1028px) {
  .web-submenu {
    left: -100px;
    width: 1100px;
  }
}

/* @media (max-width: 539px) {
  .federal_republic {
    font-size: 26px;
  }
} */
`